<script setup>
import { defineProps, defineEmits, ref } from 'vue';

const props = defineProps({
    show: {
        tyoe: Boolean,
        default: false
    }
})
const isLoading = ref(false);
const emit = defineEmits(['close', 'confirm']);

const handleConfirm = () => {
    isLoading.value = true;
    emit('confirm');
    isLoading.value = false;
}
</script>
<template>
    <Teleport to="body">
        <div v-if="props.show" class="modal-overlay" data-modal>
            <div ref="modalRef" class="modal">
                <div class="modal__header">
                    <h2 class="modal__title">Withdraw Proposal</h2>
                </div>
                <div class="modal__description">
                    <div>Are you sure you want to withdraw your proposal?</div>
                </div>
                <div class="modal__footer">
                    <button class="px-4 py-2 rounded-lg hover:bg-white/10 text-white" @click="emit('close')">Close</button>
                    <button class="text-white px-4 py-2 rounded-lg" :class="isLoading ? 'bg-echoes-primary/50 cursor-not-allowed' : 'bg-echoes-primary'" @click="handleConfirm" :disabled="isLoading">
                        {{ isLoading ? 'Withdrawing...' : 'Withdraw Proposal' }}
                    </button>
                </div>
            </div>
        </div>
    </Teleport>
</template>


<style scoped lang="postcss">
.modal-overlay {
    @apply fixed inset-0 bg-black/50 flex items-center justify-center z-40 p-2;
    backdrop-filter: blur(4px);
    animation: fadeIn 0.2s ease;
    isolation: isolate;
}

.modal {
    @apply bg-echoes-background-gray border border-echoes-border-gray/50 rounded-xl shadow-xl max-h-[85vh] mt-16 flex flex-col w-1/3 px-8;
    animation: slideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    z-index: 1;
}

.modal__header {
    @apply sticky top-0 z-10 flex items-center justify-between pt-4 p-2 border-b border-echoes-border-gray bg-echoes-background-gray rounded-t-xl;
}

.modal__title {
    @apply text-xl font-semibold text-white flex items-center gap-2;
}

.modal__description {
    @apply p-2 bg-echoes-background-gray rounded-b-xl text-sm text-white/60;
}

.modal__footer {
    @apply px-4 bg-echoes-background-gray rounded-b-xl text-sm text-white/60 flex justify-center my-4 gap-4;
}
</style>